import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: var(--bg-dark);
  padding: 4rem 0 2rem;
`;

export const FooterWrapper = styled("div")`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;

  @media only screen and (max-width: 1024px) {
    padding: 0 30px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0 18px;
  }
`;

export const FooterTop = styled("div")`
  display: flex;
  align-items: flex-start;
  margin-bottom: 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const FooterBrand = styled("div")`
  flex: 0 0 300px;

  @media only screen and (max-width: 768px) {
    flex: none;
    width: 100%;
  }
`;

export const FooterDescription = styled("p")`
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  line-height: 1.6;
  margin-top: 0.5rem;
  max-width: 280px;
`;

export const FooterColumns = styled("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  flex: 1;

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }

  @media only screen and (max-width: 414px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterColumn = styled("div")``;

export const ColumnTitle = styled("h6")`
  color: #fff;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1.25rem;
`;

export const FooterLink = styled("a")`
  display: block;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  margin-bottom: 0.75rem;
  transition: color 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    color: #fff;
  }
`;

export const FooterBottom = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

export const Copyright = styled("div")`
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;

  img {
    width: 24px;
    margin: 0 4px;
    vertical-align: middle;
  }
`;

export const FooterLegal = styled("div")`
  display: flex;
  gap: 1.5rem;

  a {
    color: rgba(255, 255, 255, 0.4);
    font-size: 13px;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: #fff;
    }
  }
`;

export const SocialLinks = styled("div")`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    transition: all 0.2s ease-in-out;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      transform: translateY(-2px);
    }

    svg {
      fill: rgba(255, 255, 255, 0.6);
      width: 18px;
      height: 18px;
    }
  }
`;

// Keep for backward compat
export const Title = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #fff;
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;
  color: rgba(255, 255, 255, 0.5);

  &:hover {
    color: #fff;
  }
`;

export const Extra = styled("section")``;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
`;

export const Large = styled(Link)`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: block;
  margin-bottom: 0.625rem;

  &:hover {
    color: #fff;
  }
`;

export const Chat = styled("p")`
  color: rgba(255, 255, 255, 0.5);
  max-width: fit-content;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: #fff;
    border-bottom-color: #fff;
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #fff;
`;

export const Label = styled("label")`
  font-size: 22px;
  text-transform: capitalize;
  color: #fff;
  display: block;
  margin-bottom: 2rem;
  font-family: "Motiva Sans Bold", serif;
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;
